export default __webpack_public_path__ + "static/media/LaidotuviuPlanavimasOrganizavimas.a1e4f939.svg";